export { default } from "./WanterVoices";
